module.exports = __webpack_public_path__ + "img/rosegold.efc7ca9.jpg";